/**
 * Call a function when a click is detected outside of the
 * current DOM node ( AND its children )
 *
 * Example :
 *
 * <template>
 *   <div v-click-outside:[arg]="onClickOutside">Hello</div>
 * </template>
 */

const ClickOutside = {
  updated(el, binding, vNode, prevVnode) {
    const opened = binding.arg;

    opened ?
      addEventListener(el, binding.value) :
      removeEventListener(el);
  }
}

const removeEventListener = (el) => {
  document.body.removeEventListener('click', el.__vueClickOutside__);
  el.__vueClickOutside__ = null;
}

const addEventListener = (el, callback) => {
  if (el.__vueClickOutside__) return;

  el.__vueClickOutside__ = event => {
    if (el.contains(event.target)) return;

    callback(event);
    event.stopPropagation();
  }

  document.body.addEventListener('click', el.__vueClickOutside__);
}

export default ClickOutside;
